import { render, staticRenderFns } from "./AdvertisingRotation.vue?vue&type=template&id=779fe1de&scoped=true&"
import script from "./AdvertisingRotation.vue?vue&type=script&lang=js&"
export * from "./AdvertisingRotation.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisingRotation.vue?vue&type=style&index=0&id=779fe1de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779fe1de",
  null
  
)

export default component.exports